export default {
	SidebarOpenedKey: 'sidebarOpened',
	LangKey: 'lang',
	ComponentSizeKey: 'componentSize',
	TokenKey: 'maToken',
	ThemeKey: 'theme',
	MsgNotifyKey: 'msgNotify'
}
